new Splide('.recommendationSplide', {
    perPage: 1,
    perMove: 1,
    gap: '32px',
    pagination: true,
    arrows: false,
    noDrag: '.no-drag',
    breakpoints: {
      767: {
        perPage: 1,
        perMove: 1,
        gap: '20px',
        arrows: false,
        pagination: true,
      },
    },
  }).mount();